export default {
  "HitPaw Online Audio Extractor": "HitPaw Online Estrattore Audio",
  "Extract sound from videos with ease.": "Estrae facilmente l'audio da video.",
  "Select Audio Format": "Seleziona formato audio",
  "Extract Audio": "Estrae Audio",
  "Extracting Audio": "Sta Estraendo Audio",
  "Extracted Successfully": "Estratto con successo",
  "Extract New": "Estrae un nuovo",
  "Extraction Failed": "Estrazione non riuscita",
  "Format": "Formato",
};
